/* @jsxImportSource react */

import type { VariantProps } from 'class-variance-authority';
import { LegacyEnergyEfficiencyFlagIcon } from './LegacyEnergyEfficiencyFlag.Icon';
import { icon } from '../EnergyEfficiencyFlag.variants';
import type { ValidColor } from '../colorsForEnergyEfficiency';
import { flag } from './LegacyEnergyEfficiencyFlag.variants';

export type LegacyEnergyEfficiencyFlagProps = {
  text: string;
  color: ValidColor;
  size?: VariantProps<typeof flag>['size'];
  'aria-label'?: string;
};

export const LegacyEnergyEfficiencyFlag = ({
  text,
  color,
  size = 'normal',
  'aria-label': srLabel,
  ...props
}: LegacyEnergyEfficiencyFlagProps) => (
  <span
    className="font-family-efficiency-label bg-color-transparent text-decoration-none relative inline-flex items-center"
    {...props}
  >
    <span className="sr-only">{srLabel}</span>
    <LegacyEnergyEfficiencyFlagIcon className={icon({ size, color })} />
    <span className={flag({ size })}>
      {text.includes('+') ? (
        <>
          {text.substring(0, 1)}
          <sup className="top-[-0.75em] left-[-0.35em] text-[0.5em]">{text.substring(1)}</sup>
        </>
      ) : (
        text
      )}
    </span>
  </span>
);
